import { SeoController } from '@application/components';
import { useRouter } from '@application/utils';
import { LoadingOverlay } from '@presentation/components';
import { AgendaConfigPage } from '@presentation/pages';
import { useEffect } from 'react';
import { useLinkProCalendar } from './api/useLinkProCalendar';
import { useProCalendarRequestAccessUrl } from './api/useProCalendarRequestAccessUrl';

export const AgendaConfigPageController = () => {
  const { url, urlLoading } = useProCalendarRequestAccessUrl();
  const { linkProCalendar, linkProCalendarLoading } = useLinkProCalendar();

  const { infoFromCurrentPath } = useRouter();

  useEffect(() => {
    // eslint-disable-next-line prefer-destructuring
    const code = infoFromCurrentPath.search.code;
    if (code) {
      linkProCalendar({ code });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [infoFromCurrentPath.search.code]);

  return (
    <>
      <LoadingOverlay transparent isLoading={urlLoading || linkProCalendarLoading} />
      <SeoController noIndex />
      {url && <AgendaConfigPage href={url} />}
    </>
  );
};
